import { hookstate, useHookstate } from "@hookstate/core"

const DeviceNameState = hookstate(null)
export const useDeviceNameState = () => {
  return useHookstate(DeviceNameState)
}
export const useDeviceName = () => {

  const deviceName = useDeviceNameState()

  return [deviceName.get(), deviceName.set]
}

const EditingDeviceNameState = hookstate(true)
export const useEditingDeviceName = () => {

  const editingDeviceName = useHookstate(EditingDeviceNameState)

  return {
    editingDeviceName: editingDeviceName.get(),
    setEditingDeviceName: editingDeviceName.set
  }
}
